import React from 'react';

import validate from '@vlabs/shared/validators';
import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const CommonSubForm = () => {
  const { t } = useTranslation();
  const { register } = useFormContext();
  const { errors } = useFormState();

  return (
    <SettingsItemWrapper title={t('handlers:policy name')}>
      <Control.Input
        autoFocus
        errors={errors}
        {...register('description', {
          maxLength: validate.maxLength(128),
          required: validate.required(),
        })}
      />
    </SettingsItemWrapper>
  );
};

export default CommonSubForm;
